import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

// Troca de senha no quarkus.
export function useChangePassword() {
  const [isSaving, setSaving] = useState(false);

  const changePassword = useCallback((payload) => {
    setSaving(true);
    return quarkusApi
      .put('/usuario/senha', payload, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { changePassword, isSaving };
}
